import React from "react";

export function MaskImage({ img, children }) {
    return (
        <i className="mask" style={{
            WebkitMaskImage: 'url(' + img + ')',
            maskImage: 'url(' + img + ')',
            backgroundImage: 'url(' + img + ')',
        }}>
            {children}
        </i>
    )
}

export function IconImage({ img }) {
    return (
        <img src={img} className="icon" alt="" />
    )
}

export function TrackEvent(event, event_params) {
    // console.log("%cgTag tracking event", "color:#ed0025;font-weight:bold;");
    // console.log('Name: ' + event);
    // event_params && console.log('Params: ' + JSON.stringify(event_params, null, 4));

    gtag('event', event, event_params && event_params);

    // e.g. output
    // gtag('event', 'search', {
    //     'context': 'search term'
    // });
}